module.exports = __webpack_public_path__ + "static/vanessaBig-d57a35b4e3482b71cba898017a61e33a.png";